import { Component, OnInit } from '@angular/core';
import { ProductStatusService } from '../../../services/product-status.service';
import { ProductService } from '../../../../products/services/product.service';


@Component({
  selector: 'app-list-product-statuses',
  templateUrl: './list-product-statuses.component.html',
  styleUrls: ['./list-product-statuses.component.css'],
  providers:[ProductStatusService,ProductService]
})
export class ListProductStatusesComponent implements OnInit {

  productStatuses:any = [];

  constructor(private productStatusService:ProductStatusService, private productService:ProductService) { }

  ngOnInit() {
    this.getProductStatuses();
  }

  getProductStatuses(){
    this.productStatusService.query({})
      .subscribe((productStatuses) => {
        this.productStatuses = productStatuses;
        this.parseProducts();
      });
  }
  parseProducts(){
    this.productStatuses.forEach(function (productStatus){
      productStatus.productTypes = "";
      if(productStatus.product_types.includes("1")){
        productStatus.productTypes += "Móviles y Tablets,";
      }
      if(productStatus.product_types.includes("2")){
        productStatus.productTypes += "Consolas,";
      }
      if(productStatus.product_types.includes("3")){
        productStatus.productTypes += "Artículos Varios,";
      }
      if(productStatus.product_types.includes("4")){
        productStatus.productTypes += "PC's-portátiles,";
      }
      productStatus.productTypes = productStatus.productTypes.substring(0,productStatus.productTypes.length - 1);
    });
  }

  delete(productStatus){
    this.productService.query({status:productStatus.id})
    .subscribe((products) => {
      if (products.length > 0){
        alert("No se puede borrar debido ha que existen productos relacionados")
      }else{
        this.productStatusService.delete(productStatus.id)
        .subscribe((productStatus) => {
          this.getProductStatuses()
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-statuses/list-product-statuses/list-product-statuses.component.ts